import { TextFieldProps } from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { FieldValues, useController } from 'react-hook-form';

import { InputAdornment } from 'common/components/InputAdornment';
import { TextField } from 'common/forms/Field';
import { TControllerProps } from 'common/types';
import { asTypedControl } from 'common/utils/form';

interface IProps extends Omit<TextFieldProps, 'name'> {
    name: string;
}

export const LinkField = <TFieldValues extends FieldValues>({
    control: formControl,
    name,
    ...other
}: IProps & TControllerProps<TFieldValues>) => {
    const control = asTypedControl<boolean>(name, formControl);
    const [translate] = useTranslation();

    const { field } = useController({ name, control });

    return (
        <TextField
            control={formControl}
            label={translate('link')}
            name={name}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            https://
                        </InputAdornment>
                    ),
                },
            }}
            type="text"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (!name) return;

                let value = e.currentTarget.value;

                // Remove protocol from url
                value = value.replace(/(^\w+:|^)\/\//, '');

                field.onChange(value);
            }}
            {...other}
        />
    );
};
